import { useHandler } from "@redotech/react-util/hook";
import { useHasPermission } from "@redotech/redo-merchant-app-common/auth/permissions-context";
import { SettingsPermissions } from "@redotech/redo-model/permissions";
import { DiscountCodeNameState } from "@redotech/redo-return-ui/flows/return-flow/discount-code-name";
import {
  StepId,
  StepTypeDetailsProps,
} from "@redotech/redo-return-ui/flows/step";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const DiscountCodeNameDetails = memo(function DiscountCodeNameDetails({
  stepSelect,
  state,
  setState,
}: StepTypeDetailsProps<DiscountCodeNameState>) {
  const canEditReturnsSettings = useHasPermission(
    SettingsPermissions.SET_RETURNS_AND_CLAIMS_SETTINGS,
  );
  const nextStepChange = useHandler((next: StepId | undefined) => {
    setState((state) => ({ ...state, next }));
  });
  const handlePrefixChange = useHandler((prefix: string) => {
    setState((state) => ({ ...state, prefix }));
  });
  const handleSuffixChange = useHandler((suffix: string) => {
    setState((state) => ({ ...state, suffix }));
  });

  return (
    <>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Discount code prefix
        </Text>
        <RedoTextInput
          placeholder="Enter prefix..."
          setValue={handlePrefixChange}
          state={canEditReturnsSettings ? "default" : "readonly"}
          value={state.prefix}
        />
        <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
          Prefix that will be prepended to any created discount codes
        </Text>
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Discount code suffix
        </Text>
        <RedoTextInput
          placeholder="Enter suffix..."
          setValue={handleSuffixChange}
          state={canEditReturnsSettings ? "default" : "readonly"}
          value={state.suffix}
        />
        <Text fontSize="xxs" fontWeight="regular" textColor="tertiary">
          Suffix that will be appended to any created discount codes
        </Text>
      </Flex>
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          Next step
        </Text>
        {stepSelect({ value: state.next, valueChange: nextStepChange })}
      </Flex>
    </>
  );
});
